<template>
  <div class='animated fadeIn'>
    <b-row>
      <b-col md='12'>
        <b-card>
          <div slot='header'>
            <strong><i class="fa fa-align-justify"></i> Détail de l'actualité </strong>
          </div>
          <div class="can-edit" v-if="canEdit">
            <b-row>
              <b-form-group label='Date de début'
                            label-for='date_debut'
                            class="col-lg-4 col-md-6 col-sm-12">
                <b-form-input id='date_debut'
                              type='date'
                              :class="{hasError: errors.date_debut !== ''}"
                              v-model="date_debut">
                </b-form-input>
                <span class='field-error'>{{ errors.date_debut }}</span>
              </b-form-group>
            </b-row>
            <b-row>
              <b-form-group label='Date de fin'
                            label-for='date_fin'
                            class="col-lg-4 col-md-6 col-sm-12">
                <b-form-input id='date_fin'
                              type='date'
                              v-model="date_fin">
                </b-form-input>
              </b-form-group>
            </b-row>
            <b-form-group label='Titre'
                          label-for='titre'>
              <b-form-input id='titre'
                            type='text'
                            :class="{hasError: errors.titre !== ''}"
                            v-model="titre">
              </b-form-input>
              <span class='field-error'>{{ errors.titre }}</span>
            </b-form-group>
            <b-form-group label='Resumé' v-if="nature !== 'Météo'">
              <ckeditor :editor="editor" v-model="resume" :config="editorConfig"></ckeditor>
            </b-form-group>
            <b-form-group label='Texte' v-if="nature !== 'Météo'">
              <ckeditor :editor="editor" v-model="texte" :config="editorConfig"></ckeditor>
            </b-form-group>
            <b-row>
              <b-form-group label="Nature"
                            label-for="nature"
                            :horizontal="true"
                            class="col-lg-4 col-md-6 col-sm-12">
                <b-form-select id="nature"
                               :class="{hasError: errors.nature !== ''}"
                               :plain="true"
                               :options="natureOptions"
                               v-model="nature">
                </b-form-select>
                <span class='field-error'>{{ errors.nature }}</span>
              </b-form-group>
            </b-row>
            <b-row>
              <b-form-group label="Pièce jointe"
                            label-for='nom_fichier'
                            class="col-lg-4 col-md-6 col-sm-12">
                <b-form-file :placeholder="pieceJointePlaceholder"
                             class="file-input"
                             drop-placeholder="Déposer le fichier ici..."
                             browse-text="Parcourir"
                             :state="errors.attachment !== '' ? false : null"
                             @change="addFile($event)">
                </b-form-file>
                <span class="field-error">{{ errors.attachment }}</span>
              </b-form-group>
            </b-row>
            <span class="mt-3 mb-3">Destinataires </span>
            <b-row>
              <b-col lg="4" md="6" sm="12" v-if="profilesReady" v-for="(element, key) in profilesOptions" :key="key">
                <b-card class="mt-3" no-body>
                  <div class="card-smallHeader card-header-action" v-b-toggle="'collapse' + key">
                      <b-form-checkbox v-model="allSelected[element.code]"
                                       :indeterminate="indeterminate[element.code]"
                                       aria-describedby="items"
                                       aria-controls="items"
                                       @change="toggleAll($event, element.code)"
                                       class="header-checkbox">
                        {{ element.code }}
                      </b-form-checkbox>
                    <div class="card-header-actions">
                      <span class="when-opened">
                        <i class="icon-arrow-down"></i>
                      </span>
                          <span class="when-closed">
                        <i class="icon-arrow-up"></i>
                      </span>
                    </div>
                  </div>
                  <b-collapse :id="'collapse' + key">
                    <b-card-body class="small-padding">
                      <b-form-checkbox v-for="profile in element.profiles"
                                       v-model="selectedRows[profile.codeLibelle]"
                                       :value="profile.id"
                                       :key="profile.id"
                                       @focus="hadnleCheckboxGroup"
                                       class="col-lg-12">
                        {{ profile.libelle }}
                      </b-form-checkbox>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </b-col>
            </b-row>

            <div slot="footer">
              <b-button type="button" @click="returnBack" size="md" variant="secondary">
                <i class="fa fa-arrow-left"></i> Liste des actualités
              </b-button>
              <b-button type="button" @click="edit('publié')" size="md" class="pull-right" variant="primary">
                <i class="fa fa-check"></i> Diffuser
              </b-button>
              <b-button type="button" @click="edit('brouillon')" size="md" class="pull-right mr-2" variant="warning">
                <i class="fa fa-save"></i> Brouillon
              </b-button>
            </div>
          </div>
          <div v-if="!canEdit">
            <div class="content-bloc">
              <label for="date_debut"><b>Date de début : </b></label>
              <span id="date_debut" class="ml-3">{{ formatDate(date_debut) }}</span>
            </div>
            <div class="content-bloc" v-if="date_fin">
              <label for="date_fin"><b>Date de fin : </b></label>
              <span id="date_fin" class="ml-3">{{ formatDate(date_fin) }}</span>
            </div>
            <div class="content-bloc">
              <label for="titre"><b>Titre : </b></label>
              <span id="titre" class="ml-3">{{ titre }}</span>
            </div>
            <div class="content-bloc" v-if="resume && nature !== 'Météo'">
              <label for="resume"><b>Resumé : </b></label>
              <p v-html="resume"></p>
            </div>
            <div class="content-bloc" v-if="texte && nature !== 'Météo'">
              <label for="texte"><b>Texte : </b></label>
              <p v-html="texte"></p>
            </div>
            <div class="content-bloc">
              <label for="nature"><b>Nature : </b></label>
              <span id="nature" class="ml-3">{{ nature }}</span>
            </div>
            <div class="content-bloc" v-if="pieceJointe">
              <label for="piece_jointe"><b>Pièce jointe : </b></label>
              <span id="piece_jointe" class="ml-3">{{ pieceJointe.nom_fichier }}</span>
            </div>
            <span class="mt-3 mb-3">Destinataires </span>
            <b-row>
              <b-col lg="4" md="6" sm="12" v-if="profilesReady" v-for="(element, key) in profilesOptions" :key="key">
                <b-card class="mt-3" no-body>
                  <div class="card-smallHeader card-header-action" v-b-toggle="'collapse' + key">
                    <b-form-checkbox v-model="allSelected[element.code]"
                                     aria-describedby="items"
                                     aria-controls="items"
                                     disabled
                                     class="header-checkbox">
                      {{ element.code }}
                    </b-form-checkbox>
                    <div class="card-header-actions">
                  <span class="when-opened">
                    <i class="icon-arrow-down"></i>
                  </span>
                      <span class="when-closed">
                    <i class="icon-arrow-up"></i>
                  </span>
                    </div>
                  </div>
                  <b-collapse :id="'collapse' + key">
                    <b-card-body class="small-padding">
                      <b-form-checkbox v-for="profile in element.profiles"
                                       v-model="selectedRows[profile.codeLibelle]"
                                       :value="profile.id"
                                       :key="profile.id"
                                       class="col-md-12"
                                       disabled>
                        {{ profile.libelle }}
                      </b-form-checkbox>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </b-col>
            </b-row>
            <div slot="footer">
              <b-button v-if="hasRule(rules.CAN_MANAGE_ACTUALITE)" type="button" @click="returnBack" size="md" variant="secondary">
                <i class="fa fa-arrow-left"></i> Liste des actualités
              </b-button>
              <b-button type="button" @click="userCanEdit" size="md" class="pull-right" variant="primary">
                <i class="fa fa-edit"></i> Modifier
              </b-button>
              <b-button type="button" @click="returnToActualite" size="md" class="pull-right mr-2" variant="warning">
                <i class="fa fa-arrow-left"></i> Retour
              </b-button>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  import '@ckeditor/ckeditor5-build-classic/build/translations/fr';
  import {isEmpty, permittedExtension} from "@/utils/fileHelper";
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../utils/auth";
  import {hasRule, espaceGestionRules as rules} from "@/utils/rulesHelper";

  const groupOrder = [
          'Pôle Flux Entrant',
          'Service Prestations',
          'Service Entreprise',
          'Pôle Qualité',
          'Relation client',
          'Direction Gestion Prévoyance',
          'Equipes Commerciales',
          'Extérieur Chorum',
          'Autres',
        ];

  const profilNotConcerned = ['0T','00','ZZ'];

  export default {
    name: "Edit",
    data() {
      return {
        date_debut: '',
        date_fin: '',
        titre: '',
        resume: '',
        texte: '',
        nature: '',
        natureOptions: [
          'Evolution Produit/CCN',
          'Evolution de services au client',
          'Information client',
          'Information interne',
          'Consigne métier',
          'Météo',
          'Autres',
        ],
        selectedProfiles: [],
        editor: ClassicEditor,
        editorConfig: {
          allowedContent: true,
          toolbar: ['heading', '|', 'bold', 'italic', '|', 'link', 'insertTable', 'tableColumn', 'tableRow', 'mergeTableCells', '|', 'indent', 'outdent', 'bulletedList', 'numberedList', 'blockQuote', '|', 'undo', 'redo'],
          language: 'fr'
        },
        errors: {
          date_debut: '',
          date_fin: '',
          titre: '',
          resume: '',
          texte: '',
          nature: '',
          attachment: '',
          destinataires: '',
        },
        profilesReady: false,
        attachment: null,
        pieceJointePlaceholder: null,
        hasRule,
        rules,
        canEdit: false,
        pieceJointe: null,
        profilesOptions: [],
        selectedRows: {
          'Service Entreprise': [],
          'Service Prestations': [],
          'Equipes Commerciales': [],
          'Direction Gestion Prévoyance': [],
          'Extérieur Chorum': [],
          'Pôle Qualité': [],
          'Relation client': [],
          'Pôle flux entrant': [],
          'Autres': [],
        },
        allSelected: {
          'Service Entreprise': false,
          'Service Prestations': false,
          'Equipes Commerciales': false,
          'Direction Gestion Prévoyance': false,
          'Extérieur Chorum': false,
          'Pôle Qualité': false,
          'Relation client': false,
          'Pôle flux entrant': false,
          'Autres': false,
        },
        indeterminate: {
          'Service Entreprise': false,
          'Service Prestations': false,
          'Equipes Commerciales': false,
          'Direction Gestion Prévoyance': false,
          'Extérieur Chorum': false,
          'Pôle Qualité': false,
          'Relation client': false,
          'Pôle flux entrant': false,
          'Autres': false,
        },
        codeLibelleArray: [
          'Service Entreprise',
          'Service Prestations',
          'Equipes Commerciales',
          'Direction Gestion Prévoyance',
          'Extérieur Chorum',
          'Pôle Qualité',
          'Relation client',
          'Pôle flux entrant',
          'Autres'
        ],
      }
    },
    mounted() {
      this.getProfiles();
      this.getActualite();
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
    },
    watch: {
      profilesOptions(newVal, oldVal) {
        // console.log(newVal, oldVal)
        // for (let code of this.codeLibelleArray) {
        //   let filteredData = newVal.filter(item => code === item.code);
        //   let count = filteredData.length > 0 ? filteredData[0].count : 0;
        //   this.hadnleCheckboxGroup(code, count);
        // }
        this.hadnleCheckboxGroup();
      },
      selectedRows: {
        deep: true,

        handler() {
          this.hadnleCheckboxGroup();
        }
      },
    },
    methods: {
      getActualite() {
        let self = this;
        this.$axios
          .get(`/espaceGestion/actualites/details/${this.$route.params.id}`)
          .then((response) => {
            this.setForm(response.data.actualite);
          })
          .catch(() => {
            this.handleErrors(self);
          });
      },
      getProfiles() {
        let self = this;
        this.$axios
          .get("/administration/profiles")
          .then((response) => {
            const profiles = response.data.profils;
            if (profiles.length > 0) {
              this.profilesReady = true;
              this.setProfiles(profiles);
            }
          })
          .catch(() => {
            this.handleErrors(self);
          });
      },
      edit(etat) {
        if(hasRule(rules.CAN_MANAGE_ACTUALITE)) {
          this.selectedProfiles = Object.values(this.selectedRows).flat();
          if (this.validateForm()) {
            let self = this;
            let formData = new FormData();
            formData.append('file', this.attachment);
            formData.append('date_debut', this.date_debut);
            formData.append('date_fin', isEmpty(this.date_fin) ? '' : this.date_fin);
            formData.append('titre', this.titre);
            formData.append('resume', this.resume);
            formData.append('texte', this.texte);
            formData.append('nature', this.nature);
            formData.append('etat', etat);
            formData.append('destinataires', this.selectedProfiles);
            this.$axios
              .post(`/espaceGestion/actualites/edit/${this.$route.params.id}`, formData, {headers: {'Content-Type': 'multipart/form-data'}})
              .then((response) => {
                this.setForm(response.data.actualite);
                this.$swal({
                  position: 'top',
                  type: 'success',
                  title: 'Modification avec succès',
                  text: "L'actualité a bien été modifiée",
                  showConfirmButton: false,
                  timer: 3000
                });
              })
              .catch(() => {
                this.handleErrors(self);
              });
          }
          else {
            this.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Vous devez saisir les champs obligatoires',
              showConfirmButton: false,
              timer: 3500
            });
          }
        }
        else {
          this.notAllowedErrorMessage();
        }
      },
      addFile(event) {
        this.attachment = event.target.files[0];
      },
      returnBack() {
        this.$router.push({path: "/espace-gestion/actualite"});
      },
      validateForm() {
        this.clearErrors();
        let isValid = true;
        if (isEmpty(this.date_debut)) {
          isValid = false;
          this.errors.date_debut = 'Veuillez choisir une date de début';
        }
        if (isEmpty(this.titre)) {
          isValid = false;
          this.errors.titre = 'Veuillez choisir un titre';
        }
        if (isEmpty(this.nature)) {
          isValid = false;
          this.errors.nature = 'Veuillez choisir une nature';
        }
        if (this.selectedProfiles.length === 0) {
          isValid = false;
          this.errors.destinataires = 'Veuillez choisir un destinataire au moins';
        }
        if (!isEmpty(this.attachment)) {
          if (!_.includes(permittedExtension, this.attachment.name.split('.').pop())) {
            isValid = false;
            this.errors.attachment = "Le Format de fichier n'est pas autorisé";
          }
        }
        return isValid;
      },
      clearErrors() {
        this.errors.date_debut = '';
        this.errors.date_fin = '';
        this.errors.titre = '';
        this.errors.resume = '';
        this.errors.texte = '';
        this.errors.attachment = '';
      },
      setForm(actualite) {
        this.date_debut = actualite.date_debut;
        this.date_fin = actualite.date_fin;
        this.titre = actualite.titre;
        this.resume = actualite.resume;
        this.texte = actualite.texte;
        this.nature = actualite.nature;
        this.setSelectedProfiles(actualite.destinataires);
        this.pieceJointePlaceholder = actualite.attachments.length > 0 ? actualite.attachments[0].nom_fichier : 'Joindre un fichier';
        this.pieceJointe = actualite.attachments.length > 0 ? actualite.attachments[0] : null;
      },
      handleErrors(self) {
        self.$swal({
          position: 'top',
          type: 'error',
          title: 'Attention !!',
          text: "Une erreur est survenue lors de l'ajout de l'actualité. Si le problème persiste, merci de faire un ticket au support DOSI.",
          showConfirmButton: false,
          timer: 4000
        });
      },
      userCanEdit() {
        if (hasRule(rules.CAN_MANAGE_ACTUALITE)) {
          this.canEdit = true;
        } else {
          this.canEdit = false;
          this.notAllowedErrorMessage();
        }
      },
      returnToActualite() {
        this.$router.push({path: "/espace-gestion/accueil"});
      },
      notAllowedErrorMessage() {
        this.$swal({
          position: 'top',
          type: 'error',
          title: 'Attention !!',
          text: "Vous n'avez pas le droit pour modifier cette actualité",
          showConfirmButton: false,
          timer: 3500
        });
      },
      formatDate(textDate) {
        return textDate !== null ? new Date(textDate).toLocaleDateString('fr-FR') : '-'
      },
      setProfiles(data) {
        this.profilesOptions = _(data)
          .filter(element => {
            if (profilNotConcerned.indexOf(element.code) === -1) {
              element.codeLibelle = this.getCodeLibelleFromCodeSubstring(element.code);
              return element;
            }
            return false;
          })
          .groupBy('codeLibelle')
          .map((value, key) => {
            return ({code: key, profiles: value, count: value.length});
          })
          .sortBy((val) => {
            return groupOrder.indexOf(val.code);
          })
          .value();
          // console.log('this.profilesOptions',this.profilesOptions)
      },
      toggleAll(checked, code) {
        let filteredData = this.profilesOptions.filter(item => code === item.code);
        let profiles = filteredData.length > 0 ? filteredData[0].profiles : [];
        this.selectedRows[code] = checked ? profiles.map(item => {
          return code === item.codeLibelle ? item.id : null;
        }) : [];
      },
      getCodeLibelleFromCodeSubstring(code) {
        if(code.includes('Presta_')) {
          return 'Service Prestations';
        }
        if(code.includes('ENT_')) {
          return 'Service Entreprise';
        }
        if(code.includes('DEV_')) {
          return 'Equipes Commerciales';
        }
        if(code.includes('Admin_')) {
          return 'Direction Gestion Prévoyance';
        }
        if(code.includes('DGP_')) {
          return 'Direction Gestion Prévoyance';
        }
        if(code.includes('EXT_')) {
          return 'Extérieur Chorum';
        }
        if(code.includes('Qual_')) {
          return 'Pôle Qualité';
        }
        if(code.includes('RC_')) {
          return 'Relation client';
        }
        if(code.includes('QC_')) {
          return 'Pôle flux entrant';
        }
        else {
          return 'Autres';
        }
      },
      setSelectedProfiles(data) {
        let formatedData = _(data)
          .filter(element => {
            // element.codeLibelle = this.getCodeLibelleFromCodeSubstring(element.code);
            // return element;
            if (profilNotConcerned.indexOf(element.code) === -1) {
              element.codeLibelle = this.getCodeLibelleFromCodeSubstring(element.code);
              return element;
            }
            return false;
          })
          .groupBy('codeLibelle')
          .map((value, key) => ({code: key, profiles: value}))
          .value();
        for(let element of formatedData){
          this.selectedRows[element.code] = element.profiles.map(item => {
            return element.code === item.codeLibelle ? item.id : null;
          });
        }
        this.hadnleCheckboxGroup();
      },
      hadnleCheckboxGroup() {
        for (let code of this.codeLibelleArray) {
          let filteredData = this.profilesOptions.filter(item => code === item.code);
          let count = filteredData.length > 0 ? filteredData[0].count : 0;
          this.manageCheckboxGroup(code, count);
        }
      },
      manageCheckboxGroup(codeLibelle, count) {
        if (this.selectedRows[codeLibelle].length === 0) {
          this.allSelected[codeLibelle] = false
          this.indeterminate[codeLibelle] = false
        } else if (this.selectedRows[codeLibelle].length === count) {
          this.allSelected[codeLibelle] = true
          this.indeterminate[codeLibelle] = false
        } else {
          this.allSelected[codeLibelle] = false
          this.indeterminate[codeLibelle] = true
        }
        // console.log(codeLibelle, count,this.selectedRows[codeLibelle])
      }
    }
  }
</script>
